import { render, staticRenderFns } from "./menageOil.vue?vue&type=template&id=1b046dfc&scoped=true"
import script from "./menageOil.vue?vue&type=script&lang=js"
export * from "./menageOil.vue?vue&type=script&lang=js"
import style0 from "./menageOil.vue?vue&type=style&index=0&id=1b046dfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b046dfc",
  null
  
)

export default component.exports